import { Skeleton } from '@/components/ui/skeleton';

export default function DirectoryCardSkeleton() {
  return (
    <div className={'border-border-primary bg-surface-primary inline-flex w-full items-center gap-2 rounded-md border p-2'}>
      <Skeleton className={'size-10 shrink-0 rounded-sm'} />
      <div className={'w-full'}>
        <Skeleton className={'h-3 w-14 rounded-md'} />
      </div>
    </div>
  );
}
